/**
 * Query to fetch categories associated with a seller
 */
const sellerCategoriesQuery = `
query GetSellerCategories($sellerId: ID!) {
  marketplace_seller(id: $sellerId) {
    objectId
    categories {
      edges {
        node {
          objectId
          name
          b2b
          b2c
          icon {
            url
          }
          cover {
            url
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellerCategoriesQuery;